var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"recipe-edit-content"},[_c('div',{staticClass:"d-none d-md-flex justify-content-center"},[_c('MPButton',{staticClass:"edit-button",attrs:{"color":"primary"},on:{"click":_vm.onClick}},[_c('Edit',{staticClass:"mr-2"}),_vm._v(" Edit Recipe ")],1)],1),_c('div',{staticClass:"recipe-edit-content-container"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }